<template>
    <v-content>
        <v-header v-if="$router.currentRoute.path !== '/login'"></v-header>
        <router-view></router-view>
        <v-add-potentials v-if="$router.currentRoute.path !== '/login'"></v-add-potentials>
    </v-content>
</template>

<script>
    import vHeader from './vHeader';
    import vAddPotentials from './vAddPotentials';
    export default {
        name: 'MainApp',
        components: {
            vHeader,
            vAddPotentials
        },
        data: () => {
            return {
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
